module.exports = __webpack_public_path__ + "media/images/logo-eeb2a707.png";